import requester from '@/lib/axios';
import { DNDPositionalActivity } from '@/models/_deprecated/ActivityElement';

const baseUrl = 'dnd-positional-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export async function createDndPositionalQuestionIntoActivity(
  activityId: number,
  body: Pick<
    DNDPositionalActivity,
    'type' | 'identifier' | 'order' | 'title' | 'subtitle'
  >,
) {
  const { data } = await requester().post<DNDPositionalActivity>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
}

export async function updateDndPositionalQuestionIntoActivity(
  activityId: number,
  id: number,
  changes: Pick<DNDPositionalActivity, 'title' | 'subtitle'>,
) {
  const { data } = await requester().patch<DNDPositionalActivity>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
}

export async function getDndPositionalActivity(
  dndPositionalActivityId: number,
): Promise<DNDPositionalActivity> {
  const { data } = await requester().get<DNDPositionalActivity>(
    `/${baseUrl}/${dndPositionalActivityId}/`,
  );

  return data;
}
